import React, { Component } from 'react';
import { Icon } from 'antd';

class Activity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activity: {},
    };
  }

  componentWillMount() {
    const { activity } = this.props;
    this.setState({
      activity,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ activity: nextProps.activity });
  }

  render() {
    const { activity } = this.state;
    const { showDrawer } = this.props;
    return (
      <span
        id={`activity${activity.index ? activity.index : '0'}`}
        onClick={() => showDrawer(activity)}
        style={{ marginRight: 5 }}
      >
        <Icon type="user" />
        <span>{activity.name ? activity.name : ''}</span>
        <Icon type="arrow-right" />
      </span>
    );
  }
}

export default Activity;



// WEBPACK FOOTER //
// ./src/components/boss/workflow/template/Activity.js